export const CONSOLE_LOADING="app/console/CONSOLE_LOADING"
export const SET_CONSOLE_OPTION="app/console/SET_CONSOLE_OPTION"
